<template>
  <el-row>
    <el-col :lg="12" :md="24" :sm="24" :xl="8" :xs="24">
      <video-show-comp/>
    </el-col>
    <el-col :lg="12" :md="24" :sm="24" :xl="8" :xs="24">
      <video-show-comp/>
    </el-col>
    <el-col :lg="12" :md="24" :sm="24" :xl="8" :xs="24">
      <video-show-comp/>
    </el-col>
    <el-col :lg="12" :md="24" :sm="24" :xl="8" :xs="24">
      <video-show-comp/>
    </el-col>
  </el-row>
</template>

<script>
import VideoShowComp from "@/views/basic_operations/monitoring/video_surveillance/comp/VideoShowComp";

export default {
  name: "VideoListComp",
  components: {VideoShowComp}
}
</script>

<style scoped>

</style>